import { newAmount } from '@orus.eu/amount'

export const frMrgaFixedLimitsOfIndemnity_v1_0_0 = {
  civilLiabilityPropertyDamage: newAmount(100_000_000),
  publicLiabilityYearly: newAmount(5_000_000),
  driverProtectionFourWheels: newAmount(250_000),
  driverProtectionTwoWheels: newAmount(30_000),
}
